<template><div><h2>如何实现<code>weui.io</code>或者星巴克页面的设置顶部bar和页面下拉背景色</h2>
<p>微信对于部分合作方开放了<code>jssdk</code>的<code>setBounceBackground</code>及<code>setNavigationBarColor</code>权限，目测暂无申请入口。</p>
</div></template><script>
export default {
  head: {"title":"其他问题 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// other-312.vue?84bbacea